/**
 * Functions related to toggle selection functionality
 *
 * @param selectedElement
 * @param triggerElement
 * @param activeClass
 */

export const toggleSelection = (triggerElement, selectedElement, additionalElement = false, activeClass = 'is-active') => {
	const triggerElements = document.querySelectorAll(triggerElement),
		selectedElements = document.querySelectorAll(selectedElement),
		additionalElements = document.querySelectorAll(additionalElement);

	function toggleSelected(el) {
		el.preventDefault();
		const count = this.getAttribute('data-count');

		triggerElements && triggerElements.forEach(item => item.classList.remove(activeClass));
		selectedElements && selectedElements.forEach(item => item.classList.remove(activeClass));
		additionalElements && additionalElements.forEach(item => item.classList.remove(activeClass));

		triggerElement && document.querySelector(`${triggerElement}[data-count="${count}"]`).classList.toggle(activeClass);
		selectedElement && document.querySelector(`${selectedElement}[data-count="${count}"]`).classList.toggle(activeClass);
		additionalElement && document.querySelector(`${additionalElement}[data-count="${count}"]`).classList.toggle(activeClass);
	}

	triggerElements && triggerElements.forEach(item => item.addEventListener('click', toggleSelected));
}
